import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors } = useTheme();
  const commonTextStyles = css`
    font-family: FS Dillon;
    color: ${colors.navy};
    text-align: left;
  `;
  return {
    CFAOpenFiltersMSGCont: isMapPage => css`
      width: 100%;
      padding: ${isMapPage ? '0' : '0 5rem'};
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      ${isMapPage &&
      css`
        & > :nth-child(1) {
          margin-bottom: 0.5rem;
        }
      `}

      ${!isMapPage &&
      css`
        ${breakpoints.mm_s_m} {
          margin-top: 1rem;
          padding: 0 2.5rem;
        }
        ${breakpoints.mm_xs_s} {
          margin-top: 1rem;
          padding: 0 2.5rem;
        }
        ${breakpoints.mm_xxs_xs} {
          margin-top: 1rem;
          padding: 0 0.75rem;
        }
      `}
    `,
    CFAOFTitle: css`
      ${commonTextStyles};
      font-weight: 700;
      font-size: 2.22rem;
      line-height: 2.5rem;
      letter-spacing: 0.0018rem;
      ${breakpoints.mm_m_l} {
        font-size: 1.944rem;
        letter-spacing: 0.0016rem;
      }
      ${breakpoints.mm_s_m} {
        font-size: 1.944rem;
        letter-spacing: 0.0016rem;
      }
      ${breakpoints.mm_xs_s} {
        font-size: 1.944rem;
        letter-spacing: 0.0016rem;
      }
      ${breakpoints.mm_xxs_xs} {
        font-size: 1.944rem;
        letter-spacing: 0.0016rem;
      }
    `,
    CFAOFSubTitle: css`
      ${commonTextStyles};
      font-weight: 400;
      font-size: 1.125rem;
      line-height: 1.5rem;
      letter-spacing: 0.0027rem;
      ${breakpoints.mm_m_l} {
        line-height: 1.375rem;
        margin-top: 0.5rem;
      }
      ${breakpoints.mm_s_m} {
        line-height: 1.375rem;
        margin-top: 0.5rem;
      }
      ${breakpoints.mm_xs_s} {
        line-height: 1.375rem;
        margin-top: 0.5rem;
      }
      ${breakpoints.mm_xxs_xs} {
        line-height: 1.375rem;
        margin-top: 0.5rem;
      }
    `,
    CFAOFButton: isMapPage => css`
      font-family: FS Dillon;
      min-width: ${isMapPage ? '0' : '19.438rem'};
      width: ${isMapPage ? '100%' : 'unset'};
      padding: 0.875rem 4.25rem;
      margin-top: ${isMapPage ? '1.5rem' : '1.875rem'};
      text-transform: uppercase;
      color: ${colors.white};
      background-color: ${colors.red};
      transition: background-color ease 0.3s;
      outline: none;
      border: none;
      border-radius: 0.25rem;
      cursor: pointer;
      letter-spacing: 0.02rem;
      line-height: 1.25rem;
      font-size: 1rem;
      font-weight: 500;
      &:hover {
        @media (hover: hover) {
          background-color: ${colors.blue};
        }
      }
      &:focus-visible:not(:hover) {
        background-color: ${colors.skip_yellow};
        border: 2px solid ${colors.border_black};
        text-decoration: underline;
        color: ${colors.border_black};
        text-decoration-color: ${colors.border_black};
      }

      ${breakpoints.mm_m_l} {
        font-size: 0.875rem;
      }
      ${breakpoints.mm_s_m} {
        font-size: 0.875rem;
      }
      ${breakpoints.mm_xs_s} {
        font-size: 0.875rem;
        align-self: flex-start;
      }
      @media (min-width: 375px) and (max-width: 440px) {
        align-self: center;
      }
      ${breakpoints.mm_xxs_xs} {
        font-size: 0.875rem;
        align-self: center;
        min-width: 100%;
      }
    `,
  };
};
